export default __webpack_public_path__ + "static/media/JobsIcon.22f9da87.svg";